module.exports = __webpack_public_path__ + "static/media/HeshanPeiris.22b64ab3.png";